/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * SAFc Backend
 * The 24/7 API description
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import healthControllerPingMutator from '../response-type.js';
import healthControllerGetVersionMutator from '../response-type.js';
import healthControllerGetHealthApiMutator from '../response-type.js';
import healthControllerGetHealthDbMutator from '../response-type.js';
import healthControllerGetHealthSumsubMutator from '../response-type.js';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const healthControllerPing = (
    
 options?: SecondParameter<typeof healthControllerPingMutator>,signal?: AbortSignal
) => {
      
      
      return healthControllerPingMutator<string>(
      {url: `/api/ping`, method: 'GET', signal
    },
      options);
    }
  



export const getHealthControllerPingQueryKey = () => {
    return [
    `/api/ping`
    ] as const;
    }

    
export const getHealthControllerPingQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerPing>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthControllerPing>>, TError, TData>, request?: SecondParameter<typeof healthControllerPingMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerPingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerPing>>> = ({ signal }) => healthControllerPing(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerPing>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthControllerPingQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerPing>>>
export type HealthControllerPingQueryError = unknown



export function useHealthControllerPing<TData = Awaited<ReturnType<typeof healthControllerPing>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthControllerPing>>, TError, TData>, request?: SecondParameter<typeof healthControllerPingMutator>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthControllerPingQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const healthControllerGetVersion = (
    
 options?: SecondParameter<typeof healthControllerGetVersionMutator>,signal?: AbortSignal
) => {
      
      
      return healthControllerGetVersionMutator<string>(
      {url: `/api/version`, method: 'GET', signal
    },
      options);
    }
  



export const getHealthControllerGetVersionQueryKey = () => {
    return [
    `/api/version`
    ] as const;
    }

    
export const getHealthControllerGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerGetVersion>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetVersion>>, TError, TData>, request?: SecondParameter<typeof healthControllerGetVersionMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerGetVersionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerGetVersion>>> = ({ signal }) => healthControllerGetVersion(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetVersion>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthControllerGetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerGetVersion>>>
export type HealthControllerGetVersionQueryError = unknown



export function useHealthControllerGetVersion<TData = Awaited<ReturnType<typeof healthControllerGetVersion>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetVersion>>, TError, TData>, request?: SecondParameter<typeof healthControllerGetVersionMutator>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthControllerGetVersionQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const healthControllerGetHealthApi = (
    
 options?: SecondParameter<typeof healthControllerGetHealthApiMutator>,signal?: AbortSignal
) => {
      
      
      return healthControllerGetHealthApiMutator<boolean>(
      {url: `/api/health/api`, method: 'GET', signal
    },
      options);
    }
  



export const getHealthControllerGetHealthApiQueryKey = () => {
    return [
    `/api/health/api`
    ] as const;
    }

    
export const getHealthControllerGetHealthApiQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError, TData>, request?: SecondParameter<typeof healthControllerGetHealthApiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerGetHealthApiQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerGetHealthApi>>> = ({ signal }) => healthControllerGetHealthApi(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthControllerGetHealthApiQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerGetHealthApi>>>
export type HealthControllerGetHealthApiQueryError = unknown



export function useHealthControllerGetHealthApi<TData = Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthApi>>, TError, TData>, request?: SecondParameter<typeof healthControllerGetHealthApiMutator>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthControllerGetHealthApiQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const healthControllerGetHealthDb = (
    
 options?: SecondParameter<typeof healthControllerGetHealthDbMutator>,signal?: AbortSignal
) => {
      
      
      return healthControllerGetHealthDbMutator<boolean>(
      {url: `/api/health/db`, method: 'GET', signal
    },
      options);
    }
  



export const getHealthControllerGetHealthDbQueryKey = () => {
    return [
    `/api/health/db`
    ] as const;
    }

    
export const getHealthControllerGetHealthDbQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError, TData>, request?: SecondParameter<typeof healthControllerGetHealthDbMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerGetHealthDbQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerGetHealthDb>>> = ({ signal }) => healthControllerGetHealthDb(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthControllerGetHealthDbQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerGetHealthDb>>>
export type HealthControllerGetHealthDbQueryError = unknown



export function useHealthControllerGetHealthDb<TData = Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthDb>>, TError, TData>, request?: SecondParameter<typeof healthControllerGetHealthDbMutator>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthControllerGetHealthDbQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const healthControllerGetHealthSumsub = (
    
 options?: SecondParameter<typeof healthControllerGetHealthSumsubMutator>,signal?: AbortSignal
) => {
      
      
      return healthControllerGetHealthSumsubMutator<boolean>(
      {url: `/api/health/sumsub`, method: 'GET', signal
    },
      options);
    }
  



export const getHealthControllerGetHealthSumsubQueryKey = () => {
    return [
    `/api/health/sumsub`
    ] as const;
    }

    
export const getHealthControllerGetHealthSumsubQueryOptions = <TData = Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError, TData>, request?: SecondParameter<typeof healthControllerGetHealthSumsubMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthControllerGetHealthSumsubQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>> = ({ signal }) => healthControllerGetHealthSumsub(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthControllerGetHealthSumsubQueryResult = NonNullable<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>>
export type HealthControllerGetHealthSumsubQueryError = unknown



export function useHealthControllerGetHealthSumsub<TData = Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthControllerGetHealthSumsub>>, TError, TData>, request?: SecondParameter<typeof healthControllerGetHealthSumsubMutator>}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthControllerGetHealthSumsubQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




